import React from 'react'
import CombinedCategories from "../components/views_title/CombinedCategories";

function Category() {
    return (
        <div>
            <CombinedCategories/>
        </div>
    )
}

export default Category;
